abstract class Middleware {
  public abstract component: any;

  public applyComponent(component: any): Middleware {
    this.component = component;
    return this;
  }
}

export { Middleware };
